export default {
  apiUrl: process.env.REACT_APP_API_URL,
  geoUrl: "https://api.mapbox.com/geocoding/v5/mapbox.places/",
  geoKey: "pk.eyJ1IjoiYW50d2FuIiwiYSI6ImNqZmFkNDlzdjEwemMzM29iNGx3czV1dHMifQ.rVPXiWLCyEkaDwZ6stZ_aQ",
  pageSize: 100,
  formatReservationNumber: function (number) {
    if (!number) {
      return "";
    }
    let str = "";
    let initialChars = 7;
    if (
      (number.length > 15 && number.indexOf("WAS") === -1) ||
      number.length > 17
    ) {
      initialChars = 9;
    }
    str = number.substr(0, initialChars) + "-";
    str += number.substr(initialChars, 1) + "-";
    str += number.substr(initialChars + 1, 4) + "-";
    if (number.indexOf("NY") > -1 || number.indexOf("BR") > -1) {
      str += number.substr(initialChars + 5, 2) + "-";
      str += number.substr(initialChars + 7);
    } else if (number.indexOf("WA") > -1) {
      str += number.substr(initialChars + 5, 4) + "-";
      str += number.substr(initialChars + 9);
    }
    return str;
  },
};
